const routes = [
    {
        path: '/atributos_produtos/:id?',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/atributos_produtos',
                redirect: '/atributos_produtos/index',
            },
            {
                name: 'listarAtributosProdutos',
                path: '/atributos_produtos/index',
                component: () => import('../views/Listar')
            },
            {
                name: 'adicionarAtributoProduto',
                path: '/atributos_produtos/adicionar',
                component: () => import('../views/Adicionar')
            },
            {
                name: 'editarAtributoProduto',
                path: '/atributos_produtos/editar/:id',
                component: () => import('../views/Editar')
            },
            {
                name: 'visualizarAtributoProduto',
                path: '/atributos_produtos/visualizar/:id',
                component: () => import('../views/Visualizar')
            }
        ]
    }
]

export default routes
